import React, { ReactNode, useContext, useEffect, useState } from 'react';

import ServiceMatrixContext from '@totem/components/portfolio/serviceMatrix/ServiceMatrixContext';
import {
  ServiceMatrix,
  ServiceMatrixColumn,
  ServiceMatrixRow,
} from '@totem/components/portfolio/serviceMatrix/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { SALES_ORDERS_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  children?: ReactNode;
};

const ServiceMatrixContainer = ({ children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);

  const [loading, setLoading] = useState<boolean>(true);
  const [columns, setColumns] = useState<ServiceMatrixColumn[]>([]);
  const [rows, setRows] = useState<ServiceMatrixRow[]>([]);
  const [searchText, setSearchText] = useState<string>('');

  useEffect(() => {
    setLoading(true);

    fetch(`${SALES_ORDERS_ENDPOINT}/serviceMatrix`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((result: ServiceMatrix) => {
        setColumns(result?.columns ?? []);

        setRows(result?.rows ?? []);
      })
      .catch(() => {
        setColumns([]);

        setRows([]);
      })
      .finally(() => setLoading(false));
  }, [getApiToken]);

  return (
    <ServiceMatrixContext.Provider
      value={{
        loading,
        columns,
        rows,
        searchText,
        setSearchText,
      }}
    >
      {children}
    </ServiceMatrixContext.Provider>
  );
};

export default ServiceMatrixContainer;
